<div class="sidebar" [ngClass]="size" *ngFor="let size of ['full', 'collapsed']">
	<div class="d-flex flex-column justify-content-center h-100">
		<div class="d-flex flex-row mb-4 ps-2" [routerLink]="['/']">
			<img class="logo" width="56" height="56" src="/assets/logo.svg" />
			<div class="ms-2 brand">
				<b>Mercury</b> <br />
				Search & Merch
			</div>
		</div>

		<a
			routerLinkActive="active"
			class="menu-link d-flex my-1 justify-content-center align-items-center"
			[routerLink]="['/']"
			[routerLinkActiveOptions]="{ exact: true }"
		>
			<div class="menu-entry py-1 px-2 d-flex justify-content-center align-items-center">
				<ng-icon name="phosphorHouse"></ng-icon>
				<span class="link-label">Home </span>
			</div>
		</a>
		<a
			routerLinkActive="active"
			class="menu-link d-flex my-1 justify-content-center align-items-center"
			[routerLink]="['/collections']"
		>
			<div class="menu-entry py-1 px-2 d-flex justify-content-center align-items-center">
				<ng-icon name="phosphorDresser"></ng-icon>

				<span class="link-label">Collections </span>
			</div>
		</a>
		<a
			routerLinkActive="active"
			class="menu-link d-flex my-1 justify-content-center align-items-center"
			[routerLink]="['/products']"
		>
			<div class="menu-entry py-1 px-2 d-flex justify-content-center align-items-center">
				<ng-icon name="phosphorShirtFolded"></ng-icon>
				<span class="link-label">Products </span>
			</div>
		</a>
		<!-- <a
			*ngIf="_currentUrl.startsWith('/products')"
			routerLinkActive="active"
			class="menu-link sub d-flex my-1 justify-content-center align-items-center"
			[routerLink]="['/products/badges']"
			
			><div class="menu-entry py-1 px-2 d-flex justify-content-center align-items-center">
				<span class="link-label">Badges </span>
				</div
		></a>
		<a
			*ngIf="_currentUrl.startsWith('/products')"
			routerLinkActive="active"
			class="menu-link sub d-flex my-1 justify-content-center align-items-center"
			[routerLink]="['/settings/global/colours']"
			
			><div class="menu-entry py-1 px-2 d-flex justify-content-center align-items-center">
				<span class="link-label">Swatching </span>
				</div
		></a> -->
		<a
			routerLinkActive="active"
			class="menu-link d-flex my-1 justify-content-center align-items-center"
			[routerLink]="['/merchandise/campaigns']"
		>
			<div class="menu-entry py-1 px-2 d-flex justify-content-center align-items-center">
				<ng-icon name="phosphorTag"></ng-icon>
				<span class="link-label">Merchandise </span>
			</div>
		</a>
		<a
			routerLinkActive="active"
			class="menu-link d-flex my-1 justify-content-center align-items-center"
			[routerLink]="['/search/incoming-terms']"
		>
			<div class="menu-entry py-1 px-2 d-flex justify-content-center align-items-center">
				<ng-icon name="phosphorMagnifyingGlass"></ng-icon>
				<span class="link-label">Search </span>
			</div>
		</a>
		<a
			routerLinkActive="active"
			class="menu-link d-flex my-1 justify-content-center align-items-center"
			[routerLink]="['/zones']"
		>
			<div class="menu-entry py-1 px-2 d-flex justify-content-center align-items-center">
				<ng-icon name="phosphorSquaresFour"></ng-icon>
				<span class="link-label">Zones </span>
			</div>
		</a>
		<!-- <a
			routerLinkActive="active"
			class="menu-link d-flex my-1 justify-content-center align-items-center"
			[routerLink]="['/bundles']"
		>
			<div class="menu-entry py-1 px-2 d-flex justify-content-center align-items-center">
				<ng-icon name="phosphorCardsThree"></ng-icon>
				<span class="link-label">Bundles </span>
			</div>
		</a> -->
		<a
			routerLinkActive="active"
			class="menu-link d-flex my-1 justify-content-center align-items-center"
			[routerLink]="['/cart']"
		>
			<div class="menu-entry py-1 px-2 d-flex justify-content-center align-items-center">
				<ng-icon name="phosphorShoppingCart"></ng-icon>
				<span class="link-label">Cart </span>
			</div>
		</a>
		<!-- <a
			routerLinkActive="active"
			class="menu-link d-flex my-1 justify-content-center align-items-center"
			[routerLink]="['/enrichment']"
		>
			<div class="menu-entry py-1 px-2 d-flex justify-content-center align-items-center">
				<ng-icon name="phosphorMagicWand"></ng-icon>
				<span class="link-label">Autotagger </span>
			</div>
		</a> -->
		<!-- <a
			routerLinkActive="active"
			class="menu-link d-flex my-1 justify-content-center align-items-center"
			[routerLink]="['/analytics']"
		>
			<div class="menu-entry py-1 px-2 d-flex justify-content-center align-items-center">
				 name="bar-
				 		<ng-icon name="phosphorLink"></ng-icon>
				 -feather><span class="link-label">Analytics </span>
			</div></a
		> -->
		<div class="mt-auto">
			<!-- <a
				routerLinkActive="active"
				class="mt-1 menu-link d-flex justify-content-center align-items-center text-muted"
			>
				<div class="menu-entry py-1 px-2 d-flex justify-content-center align-items-center">
					 name="code"
					 		<ng-icon name="phosphorLink"></ng-icon>
					 <span class="link-label">Popout</span>
				</div>
			</a> -->
			<a
				*ngIf="store?.isActive"
				routerLinkActive="active"
				href="https://docs.plutocracy.io/plutocracy/mercury/quick-start"
				class="mt-1 menu-link d-flex justify-content-center align-items-center text-muted"
			>
				<div class="menu-entry py-1 px-2 d-flex justify-content-center align-items-center">
					<ng-icon name="phosphorCode"></ng-icon>
					<span class="link-label">Developers</span>
				</div>
			</a>

			<span
				routerLinkActive="active"
				(click)="intercom()"
				class="menu-link d-flex justify-content-center align-items-center text-muted"
			>
				<div class="menu-entry py-1 px-2 d-flex justify-content-center align-items-center actionable">
					<ng-icon name="phosphorLifebuoy"></ng-icon>
					<span class="link-label">Support</span>
				</div></span
			>

			<a
				routerLinkActive="active"
				[routerLink]="store?.isActive ? ['/settings/global/store'] : ['/settings/global/billing']"
				class="menu-link d-flex justify-content-center align-items-center text-muted"
			>
				<div class="menu-entry py-1 px-2 d-flex justify-content-center align-items-center">
					<ng-icon name="phosphorGear"></ng-icon>
					<span class="link-label">Settings</span>
				</div></a
			>

			<!-- <a routerLinkActive="active" class="menu-link d-flex my-2 ms-auto align-items-center btn-sm btn btn-primary"
			target="_blank" (click)="deepLinkUrl()">
			Install UI
		</a> -->
		</div>
	</div>
</div>
